<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">平台概览</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="show_li">
          <div class="show_li_content">
            <div class="show_li_content_li content" @click="viewClick('RegisteredUsers')" style="border:1px solid #000">
              <h3>注册用户</h3>
              <div >
                <span>今日注册数</span>
                <span class="show_li_content_li_num">{{tyData[0].register == undefined?0:tyData[0].register}}</span>
              </div>
              <div >
                <span>昨日注册数</span>
                <span class="show_li_content_li_num">{{tyData[1].register == undefined?0:tyData[1].register}}</span>
              </div>
              <div style="margin:10px 0 " >更多></div>
            </div>
            <div class="show_li_content_li content"  @click="viewClick('activeUsers')" style="border:1px solid #000">
              <h3>小程序活跃</h3>
              <div >
                  <span>今日活跃数</span>
                  <span class="show_li_content_li_num">{{tyData[0].active == undefined?0:tyData[0].active}}</span>
                </div>
                <div >
                <span>昨日活跃数</span>
                <span class="show_li_content_li_num">{{tyData[1].active == undefined?0:tyData[1].active}}</span>
              </div>
              <div style="margin:10px 0 ">更多></div>
            </div>
            <div class="show_li_content_li content"  @click="viewClick('activeUsers')" style="border:1px solid #000">
              <h3>麻将机活跃</h3>
              <div >
                  <span>今日活跃数</span>
                  <span class="show_li_content_li_num">{{tyData[0].machine == undefined?0:tyData[0].machine}}</span>
                </div>
                <div >
                <span>昨日活跃数</span>
                <span class="show_li_content_li_num">{{tyData[1].machine == undefined?0:tyData[1].machine}}</span>
              </div>
              <div style="margin:10px 0 ">更多></div>
            </div>
            <div class="show_li_content_li content" style="border:1px solid #000">
              <h3>游戏数据</h3>
              <div >
                  <span>今日局数</span>
                  <span class="show_li_content_li_num">0</span>
                </div>
                <div >
                <span>昨日局数</span>
                <span class="show_li_content_li_num">0</span>
              </div>
              <div style="margin:10px 0 ">更多></div>
            </div>
            <div class="show_li_content_li content" style="border:1px solid #000">
              <h3>收入数据</h3>
              <div >
                  <span>今日收入</span>
                  <span class="show_li_content_li_num">0</span>
                </div>
                <div >
                <span>昨日收入</span>
                <span class="show_li_content_li_num">0</span>
              </div>
              <div style="margin:10px 0 ">更多></div>
            </div>
          </div>
        </div>


        <div class="show_li">
          <div class="show_li_title">共享桌费分润收益</div>
          <div style="margin-top:20px;margin-left:80px">
            <el-radio-group v-model="radioType" size="small">
              <el-radio-button label="今日"></el-radio-button>
              <el-radio-button label="昨日"></el-radio-button>
              <el-radio-button label="本月"></el-radio-button>
              <el-radio-button label="上月"></el-radio-button>
            </el-radio-group>
            <el-button size="small" type="primary" v-preventReClick class="title" @click="viewClick('TableFeeIncome')">更多</el-button>
          </div>
          <div class="show_li_content">
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.ordernum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.ordernum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.ordernum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.ordernum}}</div>
              <div class="show_li_content_li_name">订单笔数</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.amountnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.amountnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.amountnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.amountnum}}</div>
              <div class="show_li_content_li_name">订单流水</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.sumsystemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.sumsystemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.sumsystemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.sumsystemnum}}</div>
              <div class="show_li_content_li_name">订单总收益</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.commissionnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.commissionnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.commissionnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.commissionnum}}</div>
              <div class="show_li_content_li_name">手续费收益</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.systemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.systemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.systemnum}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.systemnum}}</div>
              <div class="show_li_content_li_name">平台分润收益</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num" v-if="radioType == '今日'">{{statisticsData.today.Rounding}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '昨日'">{{statisticsData.yestoday.Rounding}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '本月'">{{statisticsData.month.Rounding}}</div>
              <div class="show_li_content_li_num" v-if="radioType == '上月'">{{statisticsData.premonth.Rounding}}</div>
              <div class="show_li_content_li_name">舍位收益</div>
            </div>
          </div>
        </div>

        
        <div class="show_li">
          <div class="show_li_title">平台销售</div>
          <div class="show_li_content">
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.saleTotal}}</div>
              <div class="show_li_content_li_name">总销售设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.salePriceTotal}}</div>
              <div class="show_li_content_li_name">总销售额</div>
            </div>
          </div>
        </div>

        <div class="show_li">
          <div class="show_li_title">平台仓库库存</div>
          <div class="show_li_content">
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.storageTotal}}</div>
              <div class="show_li_content_li_name">总入库设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.outTotal}}</div>
              <div class="show_li_content_li_name">总出库设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.faultTotal}}</div>
              <div class="show_li_content_li_name">故障设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{totalData.storageTotal - totalData.outTotal}}</div>
              <div class="show_li_content_li_name">仓库剩余设备</div>
            </div>
          </div>
        </div>

        <div class="show_li">
          <div class="show_li_title">经销商库存</div>
          <div class="show_li_content">
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{ totalData.saleTotal }}</div>
              <div class="show_li_content_li_name">总采购设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{ totalData.outTotal }}</div>
              <div class="show_li_content_li_name">总发货设备</div>
            </div>
            <div class="show_li_content_li">
              <div class="show_li_content_li_num">{{ totalData.saleTotal - totalData.outTotal }}</div>
              <div class="show_li_content_li_name">剩余未发货设备</div>
            </div>
          </div>
        </div>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { getTotal , censusTy , statistics  } from '../../api/userMG'
export default {
    data(){
        return{
          storageTotal:'',
          totalData:{},
          tyData:[],
          radioType:'今日',
          statisticsData:{},
        }
    },
    components: {
    },
    created(){
        this.getdata()
        this.censusTy()
        this.statistics()
    },
    methods:{
      statistics(){
        statistics().then(res=>{
          res.data.today.Rounding = Math.floor((res.data.today.sumsystemnum - res.data.today.systemnum)*100)/100
          res.data.yestoday.Rounding = Math.floor((res.data.yestoday.sumsystemnum - res.data.yestoday.systemnum)*100)/100
          res.data.month.Rounding = Math.floor((res.data.month.sumsystemnum - res.data.month.systemnum)*100)/100
          res.data.premonth.Rounding = Math.floor((res.data.premonth.sumsystemnum - res.data.premonth.systemnum)*100)/100
          this.statisticsData = res.data
        })
      },
      viewClick(path){
        this.$router.push(`/${path}`)
      },
      censusTy(){
        censusTy().then(res=>{
          if(res.success){
            this.tyData = res.data
          }else {
            this.$message.error(res.messages)
          }
        })
      },
      getdata(){
        getTotal().then(res=>{
          if(res.success){
            this.storageTotal = res.storageTotal
            this.totalData = res
          }else {
            this.$message.error(res.messages)
          }
        })
      },
      
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .show_li{
    width: 90%;
    /* height: 200px; */
    padding: 15px 0 ;
    background: #eee;
    margin-bottom: 20px;
  }
  .show_li_title{
    font-size: 24px;
    font-weight: 600;
    padding-left: 50px;
    padding-top: 15px;
  }
  .show_li_content{
    display: flex;
    flex-wrap: wrap;
  }
  .show_li_content_li{
    margin-top: 40px;
    margin-left: 100px;
  }
  .show_li_content_li_num{
    font-size: 28px;
  }
  .show_li_content_li_name{
    font-size: 20px;
    margin-top: 15px;
  }
  .content{
    margin-top: 10px;
    width: 150px;
    padding:0 15px;
    text-align: center;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/PlatformOverview/index.vue